// Copyright 2013 Google Inc. All Rights Reserved.

'use strict';

/**
 * @fileoverview A small library to share functions to get and set
 * jsaction parser cache entries.
 */

var Property = require('./syntax').Property;

var Cache = {};

/**
 * Reads the jsaction parser cache from the given DOM Element.
 *
 * @param {!Element} element .
 * @return {!Object.<string, string>} Map from event to qualified name
 *     of the jsaction bound to it.
 */
Cache.get = function (element) {
  return element[Property.JSACTION];
};

/**
 * Writes the jsaction parser cache to the given DOM Element.
 *
 * @param {!Element} element .
 * @param {!Object.<string, string>} actionMap Map from event to
 *     qualified name of the jsaction bound to it.
 */
Cache.set = function (element, actionMap) {
  element[Property.JSACTION] = actionMap;
};

/**
 * Clears the jsaction parser cache from the given DOM Element.
 *
 * @param {!Element} element .
 */
Cache.clear = function (element) {
  if (Property.JSACTION in element) {
    delete element[Property.JSACTION];
  }
};

/**
 * Reads the cached jsaction namespace from the given DOM
 * Element. Undefined means there is no cached value; null is a cached
 * jsnamespace attribute that's absent.
 *
 * @param {!Element} element .
 * @return {string|null|undefined} .
 */
Cache.getNamespace = function (element) {
  return element[Property.JSNAMESPACE];
};

/**
 * Writes the cached jsaction namespace to the given DOM Element. Null
 * represents a jsnamespace attribute that's absent.
 *
 * @param {!Element} element .
 * @param {?string} jsnamespace .
 */
Cache.setNamespace = function (element, jsnamespace) {
  element[Property.JSNAMESPACE] = jsnamespace;
};

/**
 * Clears the cached jsaction namespace from the given DOM Element.
 *
 * @param {!Element} element .
 */
Cache.clearNamespace = function (element) {
  if (Property.JSNAMESPACE in element) {
    delete element[Property.JSNAMESPACE];
  }
};

module.exports = Cache;



/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/jsaction/lib/cache.js
 ** module id = 194
 ** module chunks = 1
 **/